import React from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Docs = props => {

  const { setIdToPreview } = props;
  const foldersDetail = useSelector(state => state.foldersDetail);

  let docs = [];
  if (foldersDetail.subjective && foldersDetail.subjective.attachments){
    foldersDetail.subjective.attachments._embedded.documents.map((item,index) => {
      return docs.push(<div className="Fascicoli-card-body-row doc-row" key={index}>
        <div className='Fascicoli-list-info-tooltip-documents-document-1' onClick={() => setIdToPreview(item.id)}>
          <div className='row-1' style={{ display: item.documentType ? "" : "none" }}>
            <span className='Fascicoli-list-info-tooltip-documents-document-icon' ><FontAwesomeIcon icon={["fas", "file"]} /></span>
            <span className='Fascicoli-list-info-tooltip-documents-document-type' >{item.documentType}</span>
            <span className='Fascicoli-list-info-tooltip-documents-document-divider' style={{ display: (!item.period || (item.documentType && item.refYear && item.documentType.indexOf(item.refYear.toString()) > -1)) ? "none" : "" }} >/</span>
            <span className='Fascicoli-list-info-tooltip-documents-document-date' style={{ display: (!item.period || (item.documentType && item.period && item.documentType.indexOf(item.period.toString()) > -1)) ? "none" : "" }}>{item.period}</span>
          </div>
          <div className={"row-2" + (item.documentType ? " gray" : "")}>
            <span className='Fascicoli-list-info-tooltip-documents-document-icon' style={{ display: item.documentType ? "none" : "" }}><FontAwesomeIcon icon={["fas", "file"]} /></span>
            <span className={`Fascicoli-list-info-tooltip-documents-document-filename${!item.documentType ? " short-margin" : ""}`} >{item.fileName}</span>
          </div>
        </div>
      </div>);
    });
  }
  return docs;
};

export default Docs;